import script from "./UserProfileHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserProfileHeader.vue?vue&type=script&lang=ts&setup=true"

import "./UserProfileHeader.vue?vue&type=style&index=0&id=3d0cce2e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0cce2e"]])

export default __exports__